import React from 'react'
import { useRouteMatch } from 'react-router-dom'
import { PageHeader } from 'components/page-header'
import Button from '@material-ui/core/Button'
import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'
import AddOutlinedIcon from 'components/material-symbol/icons/Add'
import NewSponsorshipModal from './new-sponsorship-modal'
import { useQuery } from '@apollo/client'
import Error from 'components/error'
import { GetCoachFacilitiesAndEndorsements } from './queries'
import LinearProgress from '@material-ui/core/LinearProgress'
import SponsorshipsListView from './sponsorships-list-view'
import { useStyles } from './styles'

const Sponsorships = () => {
  const classes = useStyles()
  const { path } = useRouteMatch()

  const crumbs = [
    {
      label: 'Account',
      to: path
        .split('/')
        .slice(0, 2)
        .join('/'),
    },
  ]

  const { data, loading, error, refetch } = useQuery(
    GetCoachFacilitiesAndEndorsements,
  )

  if (error) return <Error error={error} />

  const headerAction = (
    <NewSponsorshipModal
      trigger={
        <Button
          startIcon={<AddOutlinedIcon />}
          variant="contained"
          color="primary"
        >
          New Sponsorship
        </Button>
      }
      onAdd={() => {
        refetch()
      }}
      facilities={data?.currentUser?.attributes?.facilities}
    />
  )

  return (
    <>
      <PageHeader title="Sponsorships" crumbs={crumbs} actions={headerAction} />
      {!loading && data?.coachEndorsements?.length > 0 && (
        <Box className={classes.introSection}>
          <Box className={classes.infoCard}>
            <Box className={classes.infoCardCopy}>
              <Typography className={classes.infoCardCaption}>
                Review the PGA Coach access sponsorships for individuals who are
                non-PGA Members but work at your facility. Please note this is
                access to the PGA Coach platform and not other PGA of America
                programming.
              </Typography>
            </Box>
          </Box>
        </Box>
      )}
      {loading ? (
        <Box px={[2, 5]}>
          <LinearProgress />
        </Box>
      ) : (
        <SponsorshipsListView
          endorsements={data?.coachEndorsements}
          facilities={data?.currentUser?.attributes?.facilities}
          refetch={refetch}
        />
      )}
    </>
  )
}

export default Sponsorships
